(() => {
  // resources/global/scroll-util.js
  if (!customElements.get("scroll-tracker")) {
    customElements.define(
      "scroll-tracker",
      class ScrollTracker extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this._updateScroll = this._updateScroll.bind(this);
          this.callbacks = [];
          this.lastTs = 0;
          this.lastScrollY = 0;
          this.rafRef = requestAnimationFrame(this._updateScroll);
          window.scrollTracker = this;
        }
        addListener(cb) {
          this.callbacks.push(cb);
        }
        removeListener(cb) {
          this.callbacks.splice(
            this.callbacks.findIndex((icb) => cb === icb),
            1
          );
        }
        trackElementInView(element, callback, options = { effectInViewOnly: true, inViewMargin: [0, 0, 0, 0] }) {
          let lastInView = false;
          const updateElementRect = (scrollData) => {
            const {
              effectInViewOnly,
              // eslint-disable-next-line no-unused-vars
              inViewMargin: [mTop, mRight, mBottom, mLeft] = [0, 0, 0, 0]
            } = options;
            if (!element) return;
            const data = element.getBoundingClientRect();
            data.middle = data.top + data.height / 2;
            data.viewMiddle = data.middle - window.innerHeight / 2;
            data.viewMiddleTop = data.top - window.innerHeight / 2;
            data.inView = data.top + data.height + mTop > 0 && data.top + mBottom < window.innerHeight;
            data.isLeaving = lastInView && !data.inView;
            data.isEntering = !lastInView && data.inView;
            if (!effectInViewOnly || effectInViewOnly && data.inView || data.isLeaving) callback(data, scrollData);
            lastInView = data.inView;
          };
          this.trackScroll(updateElementRect);
        }
        trackScroll(callback) {
          this.addListener(callback);
        }
        _updateScroll(time) {
          const elapsedMs = time - this.lastTs;
          if (elapsedMs >= 16) {
            const curScrollY = window.scrollY;
            const dScroll = this.lastScrollY - curScrollY;
            const trackingData = {
              dScroll,
              scrollY: curScrollY,  // FIXED: was just "scrollY" which was undefined
              lastScrollY: this.lastScrollY,
              elapsedMs,
              time
            };
            this.callbacks.forEach((cb) => cb(trackingData));
            this.lastScrollY = curScrollY;
            this.lastTs = time;
          }
          this.rafRef = requestAnimationFrame(this._updateScroll);
        }
      }
    );
  }

  // resources/global/animation.js
  if (!customElements.get("ani-scroll-view")) {
    customElements.define(
      "ani-scroll-view",
      class AniScrollView extends HTMLElement {
        constructor() {
          super();
          this._trackInView = this._trackInView.bind(this);
        }
        connectedCallback() {
          this.classList.add("ani");
          this._triggered = false;
          this._autoStagger();
          window.scrollTracker.trackElementInView(this, this._trackInView);
        }
        _autoStagger() {
          this.querySelectorAll(".ani").forEach((el, i) => {
            if (i > 0) el.style.setProperty("--ani-delay", `${i * 100}ms`);
          });
        }
        _trackInView(data) {
          const isInView = data.viewMiddle <= window.innerHeight / 3;
          if (!this._triggered && isInView) {
            this.classList.add("ani--play");
            this._triggered = true;
          }
        }
      }
    );
  }

  // resources/global/site-header.js
  if (!customElements.get("site-header")) {
    customElements.define(
      "site-header",
      class SiteHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.navIcon = this.querySelector(".nav-icon");
          this.nav = this.querySelector(".site-header__nav-group");
          this.header = this.querySelector(".site-header");
          this.searchDisclosure = this.querySelector(".site-header__search > details");
          this._listen();
        }
        _listen() {
          if (this.navIcon) {
            this.navIcon.addEventListener("click", () => {
              document.body.classList.toggle("nav-open");
              this.navIcon.classList.toggle("close");
              this.nav.classList.toggle("open");
              this.header.classList.toggle("open");
            });
          }
          if (this.searchDisclosure) {
            this.searchDisclosure.addEventListener("toggle", () => {
              if (this.searchDisclosure.open) {
                this.header.classList.add("site-header--search-open");
                setTimeout(() => {
                  this.searchDisclosure.querySelector("input").focus();
                }, 250);
              } else {
                setTimeout(() => {
                  this.header.classList.remove("site-header--search-open");
                }, 500);
                this.navIcon.focus();
              }
            });
          }
        }
      }
    );
  }
})();